export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.4.13-0905.48",
  commitId: "e183dbf51cccd91c93468b6fcfaf64fd5fbd6f09",
  commitTime: "2026-04-13T09:05:48.000Z",
});
